import { customerData } from './customerData';
import { State } from 'xstate';

export type CustomerDataMachine = typeof customerData;
export type CustomerDataState = State<CustomerDataMachine['context']>;

export const getContactDataLoading = (machineState: CustomerDataState) => ({
  isLoading: machineState.matches('loading'),
});

export const getShippingAddressStatus = (machineState: CustomerDataState) => ({
  isSaving: machineState.matches('shippingAddress.edit.saving'),
  isEdit: machineState.matches('shippingAddress.edit.idle'),
  isError: machineState.matches('shippingAddress.edit.error'),
});

export const getContactDetailsStatus = (machineState: CustomerDataState) => ({
  isSaving: machineState.matches('contactDetails.edit.saving'),
  isEdit: machineState.matches('contactDetails.edit.idle'),
  isError: machineState.matches('contactDetails.edit.error'),
});
export const getCustomerDetailsData = (machineState: CustomerDataState) => ({
  data: machineState.context.initialData,
});
export const customerDataSelectors = {
  getCustomerDetailsData,
  getShippingAddressStatus,
  getContactDetailsStatus,
  getContactDataLoading,
};
